<template>
    <div class="list" tabindex="0" @keydown="keydown">
        <div v-for="(r, ind) in entries" :key="ind" class="entry" :class="{ selected: ind===index }"
                @click="onClick(ind)">
            <slot name="entry" v-bind:entryIndex="ind" v-bind:entryValue="r">{{r}}</slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'list',
  data: function() {
    return {
      index: 0
    };
  },
  props: {
    entries: Array
  },
  watch: {
    entries(newVal) {
      console.log('watch entries');
      if ((newVal) && (newVal.length > 0)) {
        if (this.index > newVal.length - 1) {
          this.index = newVal.length - 1;
        }
        this.$emit('change', { index: this.index, entry: this.entries[this.index] });
      } else {
        this.$emit('change', { index: -1, entry: null });
      }
    }
  },
  mounted() {
    if ((this.entries) && (this.entries.length > 0)) {
      this.$emit('change', { index: this.index, entry: this.entries[this.index] });
    } else {
      this.$emit('change', { index: -1, entry: null });
    }
  },
  methods: {
    keydown(e) {
      let changed = false;
      if (e.key === 'ArrowDown') {
        if (this.index < this.entries.length - 1) {
          this.index++;
          changed = true;
        }
      } else if (e.key === 'ArrowUp') {
        if (this.index > 0) {
          this.index--;
          changed = true;
        }
      } else if (e.key === 'Home') {
        this.index = 0;
        changed = true;
      } else if (e.key === 'End') {
        this.index = this.entries.length - 1;
        changed = true;
      } else if ((e.key === ' ') || (e.key === 'Enter')) {
        this.$emit('select', { index: this.index, entry: this.entries[this.index] });
      } else {
        this.$emit('keydown', e);
      }
      if (changed) {
        this.$emit('change', { index: this.index, entry: this.entries[this.index] });
      }
    },
    onClick(ind) {
      this.index = ind;
      this.$emit('select', { index: this.index, entry: this.entries[this.index] });
    },
    selectIndex(ind) {
      this.onClick(ind);
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .list {
        // border: 1px solid $list-border;
        background: $list-background;

        .entry {
            padding: 5px;
            cursor: pointer;
            &:hover {
                background-color: $list-hover-background;
            }
            &.selected {
                background-color: $list-selected-background;
            }
        }
    }

</style>
